export function useIsProduction() {
  return process.env.NODE_ENV === 'production';
}
